module.exports = __webpack_public_path__ + "img/play.b7b7992f.svg";